/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { SignUpPageService } from '../../../services';
import { logger as log } from '@common/logger';
import { StorageModule } from '@vlinder-web/storage-module-react';

const MODULE_NAME = 'profile.machines.states.signUpuser';

const getSrv = () => {
  return vappContainer.get<SignUpPageService>(SignUpPageService.displayName);
};

export const signUpUser = async (context: any, event: any) => {
  const currentState = 'SIGN_UP_USER';
  const method = 'resiterUser';
  const storageSrv = StorageModule.getInstance();

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv?.agent?.signUpUser(event?.payload);
      console.log(`content in machine :`, content);
      if (content) {
        return resolve({
          key: 'VERIFY_USER',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = content?.error?.message;
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'SIGN_UP_USER_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'SIGN_UP_USER_FAILED',
        value: err?.message,
      });
    }
  });
};
